/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import styled from "@emotion/styled";
import colors from 'styles/colors';
import dimensions from 'styles/dimensions';
import Illustration from 'components/_ui/Illustration';
import Content from 'components/_ui/Content';
import CleanInput from 'components/_ui/CleanInput';

const DrawerContainer = styled.div`
  display: block;
  border-bottom: 1px solid ${colors.grey400};
  
  header {
    cursor: pointer;
    position: relative;
    padding: 2.4rem 4.8rem 2rem 0;
    
    &:hover {
      button {
        &::before,
        &::after {
          background-color: ${colors.green400};
        }
      }
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    header {
      position: relative;
      padding: 4rem 0;
    }
  }
`;

const DrawerContent = styled.div`
  height: 0;
  opacity: 0;
  visibility: hidden;
  
  .is-open & {
    height: auto;
    padding-bottom: 4rem;
    opacity: 1;
    visibility: visible;
    transition: opacity 0.3s ease-in-out 0.1s;
  }
  
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {   
    display: flex;
    align-items: center;
    
    .is-open & {
      padding: 6.4rem 0 8rem;
    }
  }
`;

const DrawerImage = styled.div`
  display: block;
  width: 100%;
  max-width: 40rem;
  margin: 0 auto 2.4rem;
  
  img {
    display: block;
    width: 100%;
  }
    
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 33.3334%;
    min-width: 24rem;
    order: 2;
    margin-left: 5.6vw;
    margin-bottom: 0;
  }
`;

const DrawerBlock = styled.div`
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 66.6667%;
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {
    p {
      font-size: 2.1rem;
    }
  }
`;

const DrawerToggle = styled(CleanInput)`
  width: 2.2rem;
  height: 2.2rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  
  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 2.2rem;
    height: 0.3rem;
    background-color: ${colors.red500};
    transition: background-color 0.12s ease-in-out, transform 0.12s ease-out;
  }
  
  &::after {
    transform: rotate(90deg);
  }
  
  .is-open & {
    &::after {
      transform: rotate(180deg);
    }
  }
`;

class Drawer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  toggleDrawer = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });

    const ilo = this.node.querySelector('video');

    if (ilo) {
      ilo.currentTime = 0;
      ilo.play();
    }
  };

  render() {
    const self = this;

    return (
      <DrawerContainer
        className={`${self.state.isOpen ? 'is-open' : ''}`}
        ref={node => this.node = node}
      >
        <header onClick={() => {self.toggleDrawer()}}>
          <h4>{self.props.heading}</h4>

          <DrawerToggle as='button'/>
        </header>

        <DrawerContent>
          {(self.props.image || self.props.illustration) && (
            <DrawerImage>
              {self.props.illustration && (
                <Illustration source={self.props.illustration} poster={self.props.image}/>
              )}

              {(!self.props.illustration && self.props.image) && (
                <img src={self.props.image.url} alt={self.props.image.alt} loading="lazy" />
              )}
            </DrawerImage>
          )}

          {self.props.content && (
            <DrawerBlock>
              <Content content={self.props.content}/>
            </DrawerBlock>
          )}
        </DrawerContent>
      </DrawerContainer>
    )
  }
}

export default Drawer;
